import React from 'react'
import { useCreateOfferOptionMutation } from '../Service/offerOptionsApi';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import { offerOptionTypeValues } from '../initialValues';
import { offerOptionTypeFields } from '../fields';
import { OfferOptionsRoutes } from '../../../Router/path';
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import theme from '../../../theme';
import { OfferOption } from '../Types/offerOptionsTypes';

const CreateOfferOptions = () => {
    const [createOptionType, createStatus] = useCreateOfferOptionMutation();

    const entityForm = useEntityForm<OfferOption>({
        initialData: offerOptionTypeValues as OfferOption,
        fields: offerOptionTypeFields,
        submitFn: (data) => {
            const { id, offerOptionsTypeId, offerOptionsValueId, ...rest } = data;
            const payload = {
                ...rest,
                offerOptionsTypeId,
                offerOptionsValueId,
            };
            return createOptionType(payload).unwrap();
        },
        redirectUrl: OfferOptionsRoutes.root,
        title: "Dodaj typ opcji",
        icon: <SettingsIcon sx={{ color: theme.palette.primary.main }} />,
        backUrl: OfferOptionsRoutes.root,
        groupOrder: ["Podstawowe", "Wartości"],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme.palette.primary.main }} />,
            Wartości: <SettingsIcon sx={{ color: theme.palette.primary.main }} />,
        },
        mutationStatus: createStatus,
    });
    return (
        <EntityFormLayout {...entityForm} />
    )
}

export default CreateOfferOptions

